import React, { useEffect, useRef, useState } from "react";
import styles from "./package.module.css";
import { useNavigate } from "react-router-dom";
import ContainerOptions from "common/ContainerOptions";
import ContainerHeader from "common/ContainerHeader";
import { deleteData, getAll } from "utils/queries";
import dayjs from "dayjs";
import DataTable_ from "common/DataTable";
import Badge from "common/Badge";

const Package = () => {
  const [data, setData] = useState();
  const [totalCount, setTotalCount] = useState();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const navigate = useNavigate();
  const childRef = useRef();

  const deletePackage = async (id) => {
    try {
      const result = await deleteData(`package/packages/${id}`);
      fetchAllPackages({});
      return result;
    } catch (error) {
      console.error("Error deleting package:", error);
    }
  };

  const columns = [
    {
      name: "Package  Name",
      cell: (row) => (
        <div
          className={styles.eventName}
          onClick={() => navigate(`./edit-package/${row?.id}`)}
        >
          {" "}
          {row.name}{" "}
        </div>
      ),
    },
    { name: "Tagline", selector: (row) => row.tagline },
    { name: "No of Guests ", selector: (row) => row.no_of_guests },
    // { name: "Custom Price ", selector: (row) => row.has_custom_price ? "True" : "False" },
    {
      name: "Total Price ",
      selector: (row) =>
        row.has_custom_price ? row?.custom_price_value : row?.price,
    },
    // {
    //   name: "Price",
    //   selector: (row) => row?.price,
    // },

    {
      name: "Custom Price ",
      selector: (row) => (row.has_custom_price ? "True" : "False"),
    },

    {
      name: "Custom Price Value",
      selector: (row) => row?.custom_price_value,
    },
    // {
    //   name: "Delete",
    //   cell: (row) => (
    //     <Badge
    //       style={{ color: "red", cursor: "pointer" }}
    //       onClick={() => deletePackage(row.id)}
    //       label="Delete"

    //     />
    //   ),
    // },
    {
      name: "Actions",
      cell: (row) => (
        <div className={styles.actionButtons}>
          <Badge
                              badgeClassOverride={styles.badgeClassOverride}

            // style={{ color: "green", cursor: "pointer", marginLeft: "10px" }}
            onClick={() => navigate(`./edit-package/${row?.id}`)}
            label="Edit"
          />
          <Badge
            style={{ color: "red", cursor: "pointer", marginRight: "10px" }}
            onClick={() => deletePackage(row.id)}
            label="Delete"
          />
          {/* <span>|</span> */}
        </div>
      ),
    },
  ];

  const resetFields = () => {
    childRef.current.resetFields();
  };

  const fetchAllPackages = async ({
    index = selectedTabIndex,
    limit = 10,
    offset = 0,
    search = null,
    currentDate = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    pastDate = null,
  }) => {
    try {
      let query = `package/packages?limit=${limit}&offset=${offset}`;

      if (pastDate) {
        query += `&pastDate=${pastDate}`;
      }

      if (search) {
        query += `&search=${search}`;
      }

      const result = await getAll(query);

      const Data = result?.data?.data;
      if (Data?.rows) {
        setData(Data?.rows);
        setTotalCount(Data?.totalCount);
      }
    } catch (error) {}
  };

  const containerOptions = [
    // {
    //   label: "Search",
    //   icon: "search",
    //   position: "pre",
    //   type: "search",
    //   handleOnChange: (e) => {
    //     resetFields();
    //     fetchAllPackages({ limit: 10, offset: 0, search: e?.target?.value });
    //   },
    // },
  ];

  console.log(data, "has_custom_price");

  useEffect(() => {
    fetchAllPackages({ selectedTabIndex });
  }, []);

  return (
    <>
      <div className={styles.container}>
        <ContainerHeader
          label="Packages"
          buttonLabel="Create Package"
          buttonFunction={() => {
            navigate(`./create-package`);
          }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
            marginTop: "10px",
            marginBottom: "0px",
          }}
        >
          <ContainerOptions Fields={containerOptions} />
        </div>

        <DataTable_
          handlefetchData={fetchAllPackages}
          data={data}
          totalCount={totalCount}
          columns={columns}
          ref={childRef}
        />
      </div>
    </>
  );
};

export default Package;
